<template>
  <div class="form">
    <h2 v-if="usetype == 5">{{ $lang('參賽兒童') }}</h2>
    <h2 v-else>{{ $lang('參賽家庭成員') }}</h2>
    <b-row>
      <b-col class="px-0" md="12">
        <b-form-checkbox v-model="value.showZhName" :disabled="disabled">{{
          $lang("沒有中文名")
        }}</b-form-checkbox></b-col>
      <b-col md="6" v-show="!value.showZhName">
        <b-form-group horizontal :label-cols="3" :label="$lang('姓：')" :feedback="errors.first('firstName')">
          <b-form-input type="text" v-model="value.firstName" name="firstName"
            :class="errors.has('firstName') && 'is-invalid'" v-validate="!value.showZhName ? { ...rules.ChineseName } : {}
              " :placeholder="$lang('請輸入姓氏')" :disabled="disabled" />
          <b-form-invalid-feedback :state="errors.has('firstName')">
            {{ errors.first("firstName") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6" v-show="!value.showZhName">
        <b-form-group horizontal :label-cols="3" :label="$lang('名字：')">
          <b-form-input type="text" v-model="value.lastName" name="lastName"
            :class="errors.has('lastName') && 'is-invalid'" v-validate="!value.showZhName ? rules.ChineseName : {}"
            :placeholder="$lang('請輸入名字')" :disabled="disabled" />
          <b-form-invalid-feedback :state="errors.has('lastName')">
            {{ errors.first("lastName") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('姓(外文)：')" :feedback="errors.first('firstNameOther')">
          <b-form-input type="text" v-model="value.firstNameOther" name="firstNameOther"
            :class="errors.has('firstNameOther') && 'is-invalid'" v-validate="rules.PtName"
            :placeholder="$lang('請輸入姓氏')" :disabled="disabled" />
          <b-form-invalid-feedback :state="errors.has('firstNameOther')">
            {{ errors.first("firstNameOther") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('名字(外文)：')">
          <b-form-input type="text" v-model="value.lastNameOther" name="lastNameOther"
            :class="errors.has('lastNameOther') && 'is-invalid'" v-validate="rules.PtName" :placeholder="$lang('請輸入名字')"
            :disabled="disabled" />
          <b-form-invalid-feedback :state="errors.has('lastNameOther')">
            {{ errors.first("lastNameOther") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">

        <b-form-group v-if="usetype == 0" horizontal :label-cols="3" :label="$lang('出生日期：')">
          <DatePicker ref="birthDatePicker" type="date" v-model="value.bornAt" name="bornAt" size="large"
            :class="errors.has('bornAt') && 'is-invalid'" v-validate="rules.birth" format="yyyy/MM/dd"
            :options="birthDateOptions" :disabled="disabled"
            @on-open-change="handleBirthPickerOpenChange"></DatePicker>

          <b-form-invalid-feedback :state="errors.has('bornAt')">
            {{ errors.first("bornAt") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group v-else-if="usetype == 1" horizontal :label-cols="3" :label="$lang('出生日期：')">
          <DatePicker ref="birthDatePicker" type="date" v-model="value.bornAt" name="bornAt" size="large"
            :class="errors.has('bornAt') && 'is-invalid'" v-validate="rules.birth" format="yyyy/MM/dd"
            :options="birthDateOptions" :disabled="disabled"
            @on-open-change="handleBirthPickerOpenChange"></DatePicker>
          <b-form-invalid-feedback :state="errors.has('bornAt')">
            {{ errors.first("bornAt") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group v-else horizontal :label-cols="3" :label="$lang('出生日期：')">
          <!-- 第一个为儿童 -->
          <DatePicker v-if="usetype == 5" ref="birthDatePicker" type="date" v-model="value.bornAt" name="bornAt" size="large"
            :class="errors.has('bornAt') && 'is-invalid'" v-validate="rules.childBirth" format="yyyy/MM/dd"
            :options="birthDateOptions" :disabled="disabled"
            @on-open-change="handleBirthPickerOpenChange"></DatePicker>
          <DatePicker v-else ref="birthDatePicker" type="date" v-model="value.bornAt" name="bornAt" size="large"
            :class="errors.has('bornAt') && 'is-invalid'" v-validate="rules.birth" format="yyyy/MM/dd"
            :options="birthDateOptions" :disabled="disabled"
            @on-open-change="handleBirthPickerOpenChange"></DatePicker>
          <div v-if="parentMessage && usetype == 4" class="text-danger">{{ parentMessage }}</div>
          <b-form-invalid-feedback v-if="errors.has('bornAt')" :state="errors.has('bornAt')">
            {{ errors.first("bornAt") }}
          </b-form-invalid-feedback>

        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
          <b-select v-model="value.gender" name="sex" :class="errors.has('sex') && 'is-invalid'" v-validate="rules.sex"
            :placeholder="$lang('請輸入性別')" :disabled="disabled">
            <option value="M">{{ $lang("FIELD_MALE") }}</option>
            <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
          </b-select>
          <b-form-invalid-feedback :state="errors.has('sex')">
            {{ errors.first("sex") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col v-if="usetype != 4" md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('FIELD_ID_NUMBER_TYPE')">
          <b-input-group>
            <b-form-select v-model="value.idType" name="idType" :class="errors.has('idType') && 'is-invalid'"
              v-validate="'required'" :disabled="disabled">
              <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
              <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
              <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
            </b-form-select>
            <b-form-invalid-feedback :state="errors.has('idType')">{{
              errors.first("idType")
            }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col v-if="usetype != 4" md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('FIELD_ID_NUMBER')">
          <b-form-input type="text" v-model="value.idNumber" name="idNumber"
            :class="errors.has('idNumber') && 'is-invalid'"
            v-validate="{ ...rules.idNumber, idNumber: status, idNumberNotAllZero: isPassportOrOther }"
            :placeholder="$lang('請輸入證件號碼')" :disabled="disabled" />
          <b-form-invalid-feedback :state="errors.has('idNumber')">
            {{ errors.first("idNumber") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="!disabled">
        <slot name="remove"></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    parentMessage: {
      type: String,
      required: false,
      default: "",
    },
    index: {
      type: Number,
      default() {
        return null;
      },
    },
    usetype: {
      type: Number,
      default() {
        return 4;
      },
    },
    value: {
      type: Object,
      default() {
        return {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "M",
          bornAt: "",
          idType: 1,
          idNumber: "",
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
      default() {
        return {
          ChineseName: {
            ChineseName: true,
            required: true,
          },
          PtName: {
            PtName: true,
            required: true,
          },
          birth: {
            required: true,
          },
          childBirth: {
            childBirth: true,
            required: true,
          },
          lastName: {
            required: this.showZhName || true,
          },
          firstName: {
            required: this.showZhName || true,
          },
          lastNameOther: {
            required: true,
          },
          firstNameOther: {
            required: true,
          },
          sex: {
            required: true,
          },
          idNumber: {
            required: true,
            idNumber: true,
          },
        };
      },
    },
    showZhName: Boolean,
  },
  data() {
    return {
      birthMinYear: 1951,
      birthPickerDropEl: null,
      birthYearObserver: null,
      birthDateOptions: {
        disabledDate(date) {
          return date && date.getTime() < new Date("1951/01/01").getTime();
        },
      },
    };
  },
  watch: {
    value: {
      handler(n) {
        this.$emit("update:value", n);
      },
      deep: true,
    },
    parentMessage(newVal) {
      console.log('来自父组件的 parentMessage 更新了：', newVal);
    },
  },

  computed: {
    status() {
      return this.value.idType == 1;
    },
    isPassportOrOther() {
      return this.value.idType == 2 || this.value.idType == 3;
    },
  },
  methods: {
    // OnlyableChinese(e) {
    //   //限制只能输入中文
    //   var val = e.target;
    //   val.value = val.value.replace(/[^\u4E00-\u9FA5]/g, "");
    // },
    // disableChinese(e) {
    //   //限制不能输入中文
    //   var val = e.target;
    //   val.value = val.value.replace(/[\u4E00-\u9FA5]/g, "");
    // },
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          resolve(result);
        });
      });
    },
    clean() {
      return new Promise((resolve, reject) => {
        this.$validator.reset();
        resolve(true);
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
    handleBirthPickerOpenChange(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.bindBirthYearLimit();
          this.applyBirthYearLimit();
          setTimeout(this.applyBirthYearLimit, 50);
        });
      } else {
        this.unbindBirthYearLimit();
      }
    },
    getBirthPickerDropEl() {
      const picker = this.$refs.birthDatePicker;
      return picker && picker.$refs && picker.$refs.drop && picker.$refs.drop.$el;
    },
    bindBirthYearLimit() {
      const dropEl = this.getBirthPickerDropEl();
      if (!dropEl || this.birthPickerDropEl === dropEl) return;

      this.unbindBirthYearLimit();
      this.birthPickerDropEl = dropEl;
      dropEl.addEventListener("click", this.handleBirthYearLimitClick, true);
      if (window.MutationObserver) {
        this.birthYearObserver = new MutationObserver(this.applyBirthYearLimit);
        this.birthYearObserver.observe(dropEl, {
          childList: true,
          subtree: true,
        });
      }
    },
    unbindBirthYearLimit() {
      if (this.birthYearObserver) {
        this.birthYearObserver.disconnect();
        this.birthYearObserver = null;
      }
      if (!this.birthPickerDropEl) return;

      this.birthPickerDropEl.removeEventListener("click", this.handleBirthYearLimitClick, true);
      this.birthPickerDropEl = null;
    },
    findBirthYearCell(target) {
      let node = target;
      while (node && node !== this.birthPickerDropEl) {
        if (
          node.classList &&
          node.classList.contains("ivu-date-picker-cells-cell") &&
          node.parentNode &&
          node.parentNode.classList &&
          node.parentNode.classList.contains("ivu-date-picker-cells-year")
        ) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    },
    handleBirthYearLimitClick(event) {
      const cell = this.findBirthYearCell(event.target);

      if (cell) {
        const year = parseInt(cell.textContent, 10);
        if (year < this.birthMinYear) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          this.applyBirthYearLimit();
          return;
        }
      }

      setTimeout(this.applyBirthYearLimit, 0);
      setTimeout(this.applyBirthYearLimit, 50);
    },
    applyBirthYearLimit() {
      const dropEl = this.getBirthPickerDropEl();
      if (!dropEl) return;

      const cells = dropEl.querySelectorAll(".ivu-date-picker-cells-year .ivu-date-picker-cells-cell");
      Array.prototype.forEach.call(cells, (cell) => {
        const year = parseInt(cell.textContent, 10);
        if (year < this.birthMinYear) {
          cell.classList.add("ivu-date-picker-cells-cell-disabled");
        } else {
          cell.classList.remove("ivu-date-picker-cells-cell-disabled");
        }
      });
    },
  },
  beforeDestroy() {
    this.unbindBirthYearLimit();
  },
  mounted() {
    console.log("this", this)
    console.log(this.props)
    console.log(this.usetype);
    console.log(this.parentMessage)

  },
};
</script>
